import '../App.css';
import CheckoutProduct from './checkoutproduct';
import SHeader from './header';
import SFooter from './footer';
import Address from './address';
import { useSelector, useDispatch } from 'react-redux';
import React from 'react';
import {clearCart} from "../actions/actionCreators";

function Checkout() {
    let cartQty = 0;
    let totalCost = 0;
    const dispatch = useDispatch(); 
    const cart = useSelector((state) => state.cart);
    cart.forEach((item)=>{
        cartQty += item.qty;
        totalCost += (item.qty * item.cost);
    })
    
    const removeAllItem=()=>{
        dispatch(clearCart());
    }
    
  return (
	<div className="oz-body-wrap">
		<SHeader/>
		<section>
			<div className="container">
				<div className="row   pt-50 align-items-center justify-content-center">                
						<h1 className="h1 text-black text-uppercase">CHECKOUT</h1> 
				</div>            
				<div className="row pt-1 align-items-center justify-content-center">      
                    <br/><span className="cart"> {cartQty} items in cart <span className="price"> [ ${totalCost} $USD ]</span></span>
				</div>            
			</div>
		</section>
		<section className="banner-area relative  pt-50">
			<div className="container">
                <hr className="headerHR"/> 
                <div className="flex-row d-flex justify-content-around">  
                    <div className="col">
                    
                    <span className="itemDelete lnr lnr-cross-circle" onClick={removeAllItem}></span>
                    </div>   
                    <div className="col">
                        <span className="tableHDR">Item</span>
                    </div>  
                    <div className="col">
                        <span className="tableHDR">Quantity </span>
                    </div> 
                    <div className="col">
                        <span className="tableHDR"> Unit Price ($USD)</span>
                    </div>  
                    <div className="col">
                        <span className="tableHDR"> Total ($USD)</span>
                    </div>  
                </div> 
                <hr className="headerHR"/> 
                {                
                    cart.map((items, key)=>{
                        return (
                        <React.Fragment key={key}>
                            <div className="flex-row d-flex justify-content-around">
                                <CheckoutProduct removeable={true} item={items}/>
                            </div>
                            <hr className="itemHR"/> 
                        </React.Fragment>
                    )})
                }
                <hr className="headerHR"/> 
                <div className="flex-row d-flex justify-content-around">  
                    <div className="col">
                        <span className="tableHDR">Total</span>
                    </div>  
                    <div className="col">
                        <span className="tableHDR"> - </span>
                    </div>   
                    <div className="col">
                        <span className="tableHDR">{cartQty} </span>
                    </div> 
                    <div className="col">
                        <span className="tableHDR"> - </span>
                    </div>  
                    <div className="col">
                        <span className="tableHDR"> {totalCost}</span>
                    </div>  
                </div> 
                <hr className="headerHR"/> 
			</div>
            <div className="row   pt-50 align-items-center justify-content-center">                
                    <h3 className="h3 mb-15 text-black text-uppercase">Address</h3> 
            </div> 
		</section>           
		<section>
            <Address/>
		</section>
		<SFooter/>
	</div>
  );
}

export default Checkout;
